import { ScopedSlot, ScopedSlotReturnValue, VNode } from 'vue/types/vnode';
import { version } from 'vue';
// TODO: Vue 3 waiting room
// import { Comment, Text } from 'vue'

function isSlotNotEmpty(slot: ScopedSlot | VNode[] | undefined | null, slotProps = {}): boolean {
  if (!slot) {
    return false;
  }

  // TODO: remove after migration to Vue 3
  // If we get a slot that is not a function,
  // we're in Vue 2 and there is content, so it's not empty
  if (typeof slot !== 'function') {
    return true;
  }

  return isVNodeNotEmpty(slot(slotProps));
}

function isVNodeNotEmpty(vnode: ScopedSlotReturnValue): boolean {
  if (!vnode) {
    return false;
  }

  return asArray(vnode).some((vnode) => {
    // TODO: remove special case for Vue 2 and remove '@ts-ignore' after migration to Vue 3
    if (version.startsWith('2')) {
      if (vnode === null) {
        return false;
      }

      if (typeof vnode !== 'object') {
        return Boolean(vnode);
      }

      if (Array.isArray(vnode)) {
        return Boolean(vnode.length);
      }

      if (vnode.isComment) {
        return false;
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (vnode.type === Comment) {
        return false;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!vnode.children?.length) {
        return false;
      }

      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        vnode.type === Text &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof vnode.children === 'string' &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        vnode.children.trim() === ''
      ) {
        return false;
      }
    }

    return true;
  });
}

function asArray<T>(arg: T | T[] | null) {
  if (arg === null) {
    return [];
  }
  return Array.isArray(arg) ? arg : [arg];
}

export const SlotChecker = { isSlotNotEmpty };
